import UserActions, { userActionTypes } from '@Actions/userActions';
import TrackerActions from '@Actions/trackerActions';
import OrderActions from '@Actions/orderActions';
import TenantActions from '@Actions/tenantActions';
import TaxActions from '../actions/taxActions';
import {
  put, takeLatest, all, delay,
} from 'redux-saga/effects';
import UserService from '@Services/userServices';
import { notification } from 'antd';
import CartActions from '@Actions/cartActions';
import mixpanel from 'mixpanel-browser';
import DepartmentActions from '@Actions/departmentActions';
import SentryHelpers from '../helpers/SentryHelpers';
// import * as Sentry from "@sentry/browser";


function loadjsfile(filename) {
  const fileref = document.createElement('script');
  fileref.setAttribute('type', 'text/javascript');
  fileref.setAttribute('src', filename);
  document.getElementsByTagName('head')[0].appendChild(fileref);
}
/**
 *
 */
function* _getUserProfile(action) {
  try {
    yield put(UserActions.getUserProfileLoading(true));
    const userProfile = yield UserService.getUserProfile(localStorage.getItem('tenantId'));

    const userDetail = {
      org_id: userProfile?.user?.org_id,
      organisation_name: userProfile?.user?.tenant_info?.organisation_name,
      user_id: userProfile?.user?.email,
      user_name: userProfile?.user?.first_name.trim(),
      tenant_id: userProfile?.user?.tenant_info?.tenant_id,
      tenant_name: userProfile?.user?.tenant_info?.legal_name,
    }

    localStorage.setItem('user', JSON.stringify(userDetail));
    localStorage.setItem('user_menu_config', JSON.stringify(userProfile?.user?.side_menu_bar_type || 'FIXED'));
    // Sentry.setUser(SentryHelpers.getSentryDetails(userProfile));
    // Sentry.setTags(SentryHelpers.getSentryTags(userProfile))
    mixpanel.init('fe62bd9ba5dc5b27ab7e87eaaa00cb0e', { track_pageview: false });
    const userTenants = userProfile?.user?.user_tenants;
    const userRoles = [];
    for (let i = 0; i < userTenants?.length; i++) {
      userRoles.push(userTenants[i]?.tenant_role_id);
    }
    if (!userProfile.message && userProfile.user) {
      if (!localStorage.getItem('tenantId')) {
        localStorage.setItem('tenantId', userProfile.user?.user_tenants[0]?.tenant_id);
        yield put(UserActions.setUserProfile({
          ...userProfile.user,
          user_roles: userRoles,
        }));
        yield put(CartActions.getCart(userProfile.user?.user_tenants[0]?.tenant_id));
      }
      if (!userProfile.user?.tenant_info?.tenant_id) {
        localStorage.setItem('tenantId', userProfile.user?.user_tenants[0]?.tenant_id);
        yield put(UserActions.getUserProfile());
      }
      if (action?.callback) {
        action.callback();
      }
      if (userProfile.user?.tenant_info?.currency_code) localStorage.setItem('currency_code', userProfile.user?.tenant_info?.currency_code);
      if (userProfile.user?.tenant_info?.inventory_config?.settings?.quantity_precision) localStorage.setItem('quantity_precision', userProfile.user?.tenant_info?.inventory_config?.settings?.quantity_precision);
      if (userProfile.user?.tenant_info?.global_config?.settings?.price_precision) localStorage.setItem('price_precision', userProfile.user?.tenant_info?.global_config?.settings?.price_precision);
      yield put(UserActions.setUserProfile({
        ...userProfile.user,
        user_roles: userRoles,
      }));
      yield put(DepartmentActions.getDepartments('', userProfile?.user?.tenant_info?.tenant_id, 1, 30, '', null, userProfile?.user?.tenant_info?.org_id, false));
      yield put(TrackerActions.identifyAction());
      yield put(TrackerActions.trackAction(userActionTypes.GET_USER_PROFILE.SUCCESS, {
        ...userProfile?.user,
      }));
    }
    if (userProfile.user.permissions) {
      localStorage.setItem('permissions', JSON.stringify(userProfile.user.permissions));
    }
    yield put(UserActions.getUserProfileLoading(false));
  } catch (error) {
    yield put(UserActions.getUserProfileLoading(false));
  }
}

/**
 *
 */
function* getUserProfile() {
  yield takeLatest(userActionTypes.GET_USER_PROFILE.REQUEST, _getUserProfile);
}

/**
 * @param action
 */
function* _getRoles(action) {
  try {
    yield put(UserActions.getRolesLoading(true));
    const users = yield UserService.getRoles(action.tenantId, action?.tenantDepartmentId);
    yield put(UserActions.getRolesSuccess(users));
    yield put(UserActions.getRolesLoading(false));
  } catch (error) {
    yield put(UserActions.getRolesLoading(false));
    yield put(TrackerActions.trackAction(userActionTypes.GET_ROLES.ERROR, {
      request: action,
      error,
    }));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* getRoles() {
  yield takeLatest(userActionTypes.GET_ROLES.REQUEST, _getRoles);
}

/**
 * @param action
 */
function* _getPermissions(action) {
  try {
    yield put(UserActions.getPermissionsLoading(true));
    const permissions = yield UserService.getPermissions(action.page, action.tenantId, action.roleId);
    yield put(UserActions.getPermissionsSuccess(permissions));
    yield put(UserActions.getPermissionsLoading(false));
  } catch (error) {
    yield put(UserActions.getPermissionsLoading(false));
    yield put(TrackerActions.trackAction(userActionTypes.GET_PERMISSIONS.ERROR, {
      request: action,
      error,
    }));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* getPermissions() {
  yield takeLatest(userActionTypes.GET_PERMISSIONS.REQUEST, _getPermissions);
}

/**
 * @param action
 */
function* _createUser(action) {
  try {
    yield put(UserActions.createUserLoading(true));
    const { payload } = action;

    const user = yield UserService.createUser(payload);
    if (payload.needsPermissionInit) {
      yield put(UserActions.initPermissions(payload.tenant_id, payload.role_id));
    }
    if (!user.success) {
      notification.open({
        type: 'error',
        message: user?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(TrackerActions.trackAction(userActionTypes.CREATE_USER.SUCCESS, {
        request: action?.payload,
        response: user,
      }));
      notification.open({
        type: 'success',
        message: 'User onboarding successful.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(UserActions.createUserLoading(false));
  } catch (error) {
    yield put(UserActions.createUserLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(userActionTypes.CREATE_USER.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* createUser() {
  yield takeLatest(userActionTypes.CREATE_USER.REQUEST, _createUser);
}

/**
 * @param action
 */
function* _updateRole(action) {
  try {
    yield put(UserActions.updateRoleLoading(true));
    const { payload } = action;
    const permission = yield UserService.updateRole(payload);
    if (!permission.success) {
      notification.open({
        type: 'error',
        message: permission.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(TrackerActions.trackAction(userActionTypes.UPDATE_PERMISSION.SUCCESS, {
        request: action?.payload,
        response: permission,
      }));
      notification.open({
        type: 'success',
        message: 'Permission update successfully!',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(UserActions.updateRoleLoading(false));
  } catch (error) {
    yield put(UserActions.updateRoleLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(userActionTypes.UPDATE_PERMISSION.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* updateRole() {
  yield takeLatest(userActionTypes.UPDATE_PERMISSION.REQUEST, _updateRole);
}

/**
 * @param action
 */
function* _updateUser(action) {
  try {
    yield put(UserActions.updateUserLoading(true));
    const { payload } = action;
    const user = yield UserService.updateUser(payload);
    if (!user.success) {
      notification.open({
        type: 'error',
        message: user?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(TrackerActions.trackAction(userActionTypes.UPDATE_USER.SUCCESS, {
        request: action?.payload,
        response: user,
      }));
      notification.open({
        type: 'success',
        message: 'User updated successful.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(UserActions.updateUserLoading(false));
  } catch (error) {
    yield put(UserActions.updateUserLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(userActionTypes.UPDATE_USER.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* updateUser() {
  yield takeLatest(userActionTypes.UPDATE_USER.REQUEST, _updateUser);
}

/**
 * @param action
 */
function* _updateMyUser(action) {
  try {
    yield put(UserActions.updateMyUserLoading(true));
    const { payload } = action;
    const user = yield UserService.updateMyUser(payload);
    if (!user.success) {
      notification.open({
        type: 'error',
        message: user?.message,
        duration: 4,
        placement: 'top',
      });
    } 
    else {
      if(!payload?.hideNotification) {
        notification.open({
          type: 'success',
          message: 'User updated successful.',
          duration: 4,
          placement: 'top',
        });
      }
      localStorage.setItem('user_menu_config', JSON.stringify(user?.data?.side_menu_bar_type || 'FIXED'));
      if (action.callback) {
        action.callback();
      }
    }
    yield put(UserActions.updateMyUserLoading(false));
  } catch (error) {
    yield put(UserActions.updateMyUserLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(userActionTypes.UPDATE_MY_USER.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* updateMyUser() {
  yield takeLatest(userActionTypes.UPDATE_MY_USER.REQUEST, _updateMyUser);
}

/**
 * @param action
 */
function* _requestOtp(action) {
  try {
    yield put(UserActions.requestOtpLoading(true));
    localStorage.clear();
    const requestOtpSuccess = yield UserService.requestOtp(action.payload);
    if (requestOtpSuccess.success && requestOtpSuccess.user) {
      yield put(UserActions.requestOtpSuccess(requestOtpSuccess));
    } else yield put(UserActions.requestOtpError(requestOtpSuccess.message));
    yield put(UserActions.requestOtpLoading(false));
  } catch (error) {
    yield put(UserActions.requestOtpError(error));
    yield put(UserActions.requestOtpLoading(false));
    yield put(TrackerActions.trackAction(userActionTypes.REQUEST_OTP.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* requestOtp() {
  yield takeLatest(userActionTypes.REQUEST_OTP.REQUEST, _requestOtp);
}

/**
 * @param action
 */
function* _verifyOtp(action) {
  try {
    mixpanel.init('fe62bd9ba5dc5b27ab7e87eaaa00cb0e', { track_pageview: false });
    yield put(UserActions.verifyOtpLoading(true));
    const userInfo = yield UserService.verifyOtp(action.payload);
    if (!userInfo.message && userInfo.user) {
      localStorage.setItem('h3m-procuzy-access-token', userInfo.user.accessToken);
      localStorage.setItem('h3m-procuzy-refresh-token', userInfo.user.refreshToken);
      localStorage.setItem('tenantId', userInfo?.user?.user_tenants?.[0]?.tenant_id);
      yield put(UserActions.verifyOtpSuccess(userInfo));
      notification.open({
        type: 'success',
        message: 'You are logged in to Procuzy Successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(UserActions.getUserProfile());
    } else {
      yield put(UserActions.verifyOtpError('You have entered an incorrect OTP'));
    }
    yield put(UserActions.verifyOtpLoading(false));
  } catch (error) {
    yield put(TrackerActions.trackAction(userActionTypes.VERIFY_OTP.ERROR, {
      request: action,
      error,
    }));
    yield put(UserActions.verifyOtpLoading(false));
  }
}

/**
 *
 */
function* verifyOtp() {
  yield takeLatest(userActionTypes.VERIFY_OTP.REQUEST, _verifyOtp);
}

/**
 *
 */
function* _logoutUser() {
  try {
    yield put(UserActions.logoutUserLoading(true));
    localStorage.clear();
    window.location.reload();
    mixpanel.reset();
    yield put(UserActions.logoutUserSuccess());
    window.Intercom('shutdown');
    yield put(UserActions.logoutUserLoading(false));
  } catch (error) {
    yield put(UserActions.logoutUserLoading(false));
  }
}

/**
 *
 */
function* logoutUser() {
  yield takeLatest(userActionTypes.LOGOUT_USER.REQUEST, _logoutUser);
}

/**
 * @param action
 */
function* _resendOtp(action) {
  try {
    yield put(UserActions.resendOtpLoading(true));
    const resendOtpResponse = yield UserService.resendOtp({
      sessionId: action.sessionId,
    });
    if (!resendOtpResponse.message && resendOtpResponse.user) {
      yield put(UserActions.resendOtpSuccess());
      notification.open({
        type: 'success',
        message: 'OTP sent successfully',
        duration: 4,
        placement: 'top',
      });
    }
    yield put(UserActions.resendOtpLoading(false));
  } catch (error) {
    yield put(UserActions.resendOtpLoading(false));
    yield put(TrackerActions.trackAction(userActionTypes.RESEND_OTP.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* resendOtp() {
  yield takeLatest(userActionTypes.RESEND_OTP.REQUEST, _resendOtp);
}

/**
 * @param action
 */
function* _requestCallback(action) {
  try {
    yield put(UserActions.requestCallbackLoading(true));
    const callbackResponse = yield UserService.requestCallback(action.payload);
    notification.open({
      type: 'success',
      message: 'Thanks for connecting!',
      description: 'Our team will get back to you within 24 hours',
      duration: 4,
      placement: 'top',
    });
    const customerEmailPayload = {
      to: action.payload.callbackEmail,
      from: 'Arjun Wadhwa <tech@h3mart.com>',
      subject: 'Thanks for contacting H3Mart!',
      cc: 'team@h3mart.com',
      html: `<div style="background-color: #F5F8FD; font-family: Arial, Helvetica, sans-serif; color: #353535; margin: 0px !important;">
              <div style="text-align: center; padding: 20px;">
                  <img src="https://h3-assets.s3.ap-south-1.amazonaws.com/h3mart-blue-logo.png" alt="logo" style="width: 120px" />
              </div>
              <div style="background-color: white; padding: 20px; margin: 0 5%; border-radius: 5px;">
                  <div style="font-size: 24px; font-weight: bold;">Thanks for Reaching Out!</div>
                  <div style="font-weight: 500; line-height: 30px; margin-top: 30px;">Hey ${action.payload.callbackName}! 👋</div>
                  <div style="margin-top: 20px; margin-bottom: 20px; line-height: 24px;">
                      Your request has been passed to our sales team. You can expect a response from them soon.
                  </div>
                  <div style="margin-top: 20px; margin-bottom: 60px; line-height: 24px;">
                     Exciting deals and products are coming your way soon!
                  </div>
                  <a
                      href="https://www.h3mart.com/"
                      target="_blank"
                      style="text-decoration: none; background-color: #2D7DF7; padding: 15px 30px; color: white; font-weight: 500; border-radius: 30px;"
                  >
                      EXPLORE H3MART
                  </a>
                  <div style="margin-top: 60px;">
                      <img
                          src="https://h3-assets.s3.ap-south-1.amazonaws.com/cashback-creative-quote-mail.png"
                          alt="offer"
                          style="width: 100%"
                      />
                  </div>
              </div>
              <div style="text-align: center; color: #636363; margin-bottom: 20px;">
                  <div style="margin-top: 30px; font-size: 14px;">Moraabh Ventures Private Limited</div>
                  <div style="margin-top: 10px; font-size: 10px; margin-bottom: 20px;">L-148, 5th Main Road, Sector 6, HSR Layout, Bengaluru, Karnataka 560102</div>
                  <div style="height: 20px"/>
              </div>
          </div>`,
    };
    if (action?.payload?.callbackEmail) {
      const userEmail = yield UserService.requestCallback(customerEmailPayload);
    }
    yield put(UserActions.requestCallbackLoading(false));
  } catch (error) {
    yield put(UserActions.requestCallbackLoading(false));
  }
}

/**
 *
 */
function* requestCallback() {
  yield takeLatest(userActionTypes.REQUEST_CALLBACK.REQUEST, _requestCallback);
}

/**
 * @param action
 */
function* _initPermissions(action) {
  try {
    yield put(UserActions.initPermissionsLoading(true));
    const initPermissions = yield UserService.initPermissions({
      tenant_id: action.tenantId,
      role_id: action.roleId,
    });
    yield put(UserActions.initPermissionsLoading(false));
  } catch (error) {
    yield put(UserActions.initPermissionsLoading(false));
  }
}

/**
 *
 */
function* initPermissions() {
  yield takeLatest(userActionTypes.INIT_PERMISSION.REQUEST, _initPermissions);
}

/**
 * @param action
 */
// eslint-disable-next-line require-yield
function* _switchBusinessUnit(action) {
  try {
    yield put(UserActions.getUserProfileLoading(true));
    const userProfile = yield UserService.getUserProfile(action?.tenantId);
    if (!userProfile.message && userProfile.user) {
      localStorage.setItem('tenantId', userProfile.user?.tenant_info?.tenant_id);
      const userTenants = userProfile.user?.user_tenants;
      const userRoles = [];
      for (let i = 0; i < userTenants?.length; i++) {
        userRoles.push(userTenants[i]?.tenant_role_id);
      }
      yield put(UserActions.setUserProfile({
        ...userProfile.user,
        user_roles: userRoles,
      }));
      yield put(TenantActions.getTenantsSuccess(null));
      yield put(TenantActions.getTenantsConfigurationSuccess(null));
    }
    if (userProfile.user.permissions) {
      localStorage.setItem('permissions', JSON.stringify(userProfile.user.permissions));
    }
    yield put(UserActions.getUserProfileLoading(false));
    if (action?.callback) {
      action.callback();
    }
    if (userProfile.user?.tenant_info?.tenant_id) {
      yield put(CartActions.getCart(userProfile.user?.tenant_info?.tenant_id));
    }
  } catch (error) {
    yield put(UserActions.getUserProfileLoading(false));
    yield put(TrackerActions.trackAction(userActionTypes.SWITCH_BUSINESS_UNIT.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* switchBusinessUnit() {
  yield takeLatest(userActionTypes.SWITCH_BUSINESS_UNIT.REQUEST, _switchBusinessUnit);
}

/**
 * @param action
 */
function* _updateOrg(action) {
  try {
    yield put(UserActions.updateOrgLoading(true));
    const { payload } = action;
    const user = yield UserService.updateOrg(payload);
    if (!user.success) {
      notification.open({
        type: 'error',
        message: user?.message,
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      yield put(TrackerActions.trackAction(userActionTypes.UPDATE_ORG.SUCCESS, {
        request: action?.payload,
        response: user,
      }));
      if (action.payload?.inventory_config) {
        // notification.open({
        //   type: 'success',
        //   message: 'Configuration updated successful.',
        //   duration: 4,
        //   placement: 'top',
        // });
      } else {
        notification.open({
          type: 'success',
          message: 'Organisation updated successful.',
          duration: 4,
          placement: 'top',
        });
      }
      if (action.callback) {
        action.callback();
      }
    }
    yield put(UserActions.updateOrgLoading(false));
  } catch (error) {
    yield put(UserActions.updateUserLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(userActionTypes.UPDATE_ORG.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* updateOrg() {
  yield takeLatest(userActionTypes.UPDATE_ORG.REQUEST, _updateOrg);
}

/**
 * @param action
 */
function* _getOrg(action) {
  try {
    yield put(UserActions.getOrgLoading(true));
    const users = yield UserService.getOrg(action.orgId);
    yield put(UserActions.getOrgSuccess(users));
    yield put(UserActions.getOrgLoading(false));
  } catch (error) {
    yield put(UserActions.getOrgLoading(false));
    yield put(TrackerActions.trackAction(userActionTypes.GET_ORG.ERROR, error));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* getOrg() {
  yield takeLatest(userActionTypes.GET_ORG.REQUEST, _getOrg);
}

/**
 * @param action
 */
function* _createRole(action) {
  try {
    yield put(UserActions.createRoleLoading(true));
    const createdRole = yield UserService.createRole(action.payload);
    if (createdRole?.success && action?.callback) {
      action.callback();
    }
    if (!createdRole?.success) {
      notification.open({
        type: 'error',
        message: createdRole?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(TrackerActions.trackAction(userActionTypes.CREATE_ROLE.SUCCESS, {
        request: action?.payload,
        response: createdRole,
      }));
    }
    yield put(UserActions.createRoleLoading(false));
  } catch (error) {
    yield put(UserActions.createRoleLoading(false));
    yield put(TrackerActions.trackAction(userActionTypes.CREATE_ROLE.ERROR, error));

    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 * @return {Generator<*, void, *>}
 */
function* createRole() {
  yield takeLatest(userActionTypes.CREATE_ROLE.REQUEST, _createRole);
}

/**
 * @param action
 */
function* _getPendingActions(action) {
  try {
    yield put(UserActions.getPendingActionsLoading(true));
    let mapPendingAction = false;
    if (action.actionType) mapPendingAction = true;
    const pendingActions = yield UserService.getPendingActions(mapPendingAction, action.actionType, action.page, action.limit);
    if (pendingActions?.success && action?.callback) {
      action.callback();
      yield put(UserActions.getPendingActionsSuccess(pendingActions?.data?.[0]));
    }
    if (!pendingActions?.success) {
      notification.open({
        type: 'error',
        message: pendingActions?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(UserActions.getPendingActionsLoading(false));
  } catch (error) {
    yield put(UserActions.getPendingActionsLoading(false));
    yield put(TrackerActions.trackAction(userActionTypes.GET_PENDING_ACTIONS.ERROR, error));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* getPendingActions() {
  yield takeLatest(userActionTypes.GET_PENDING_ACTIONS.REQUEST, _getPendingActions);
}

/**
 *
 */
export default function* userSaga() {
  yield all([requestOtp(), verifyOtp(), getUserProfile(), logoutUser(),
  resendOtp(), requestCallback(),
  updateUser(),
  getRoles(),
  createUser(),
  updateRole(),
  getPermissions(),
  initPermissions(),
  switchBusinessUnit(),
  updateMyUser(),
  updateOrg(),
  getOrg(),
  createRole(),
  getPendingActions(),
  ]);
}
